import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgMathClass = (props, ref) => /* @__PURE__ */ _jsxs("svg", {
	width: 116,
	height: 58,
	viewBox: "0 0 116 58",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			d: "M115.802 32.9016L104.928 43.5613L109.067 57.9967L102.325 56.1974L100.1 48.266L94.2193 54.0345L87.4411 52.2257L98.2312 41.7358L94.1404 27.1211L100.739 28.8821L103.095 37.0407L109.167 31.1311L115.802 32.9016Z",
			fill: "#06748D"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M57.5108 52.0599L53.1027 1.67432L65.987 0.547085L70.3951 50.9327L57.5108 52.0599Z",
			fill: "#4EA4BD"
		}),
		/* @__PURE__ */ _jsx("path", {
			d: "M22.8953 55.0882L0.708252 6.25806L13.5926 5.13082L27.5184 38.2919L35.6183 3.20383L48.4306 2.08289L35.0599 54.024L22.8953 55.0882Z",
			fill: "#4EA4BD"
		})
	]
});
const ForwardRef = forwardRef(SvgMathClass);
export default ForwardRef;
